import { Link } from '@tanstack/react-router'
import { Activity } from 'lucide-react'
import { useLocale, useTranslations } from 'use-intl'
import { LocalizedLink } from '~/components/common/localized-link'
import { AUTH_ROUTES, getAuthRouteTarget } from '~/lib/auth/routes'
import { ComplianceNotice } from './compliance-notice'

const currentYear = new Date().getFullYear()

export function Footer() {
  const t = useTranslations('components.layout.footer')
  const locale = useLocale()
  const signInRoute = getAuthRouteTarget(locale, AUTH_ROUTES.signIn)
  const signUpRoute = getAuthRouteTarget(locale, AUTH_ROUTES.signUp)

  return (
    <footer className="border-t border-divider/40 bg-background mt-auto">
      <div className="mx-auto max-w-6xl px-4 lg:px-6">
        <div className="flex flex-col gap-8 py-10 md:flex-row md:justify-between">
          <div className="flex flex-col gap-3 max-w-xs">
            <LocalizedLink to="/matches" className="inline-flex min-h-11 min-w-11 items-center gap-2 rounded-lg font-semibold text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
              <Activity className="size-4 text-primary" aria-hidden="true" />
              <span className="text-lg font-bold tracking-tight" translate="no">BallPeek</span>
            </LocalizedLink>
            <p className="text-sm text-muted leading-relaxed">
              {t('description')}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h3 className="mb-3 text-xs font-semibold text-foreground uppercase tracking-wider">
                {t('product')}
              </h3>
              <ul className="space-y-2">
                <li><LocalizedLink to="/matches" className="inline-flex min-h-11 min-w-11 items-center rounded-lg px-2 text-sm text-muted transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">{t('matches')}</LocalizedLink></li>
                <li><LocalizedLink to="/teams-players" className="inline-flex min-h-11 min-w-11 items-center rounded-lg px-2 text-sm text-muted transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">{t('teamsPlayers')}</LocalizedLink></li>
              </ul>
            </div>
            <div>
              <h3 className="mb-3 text-xs font-semibold text-foreground uppercase tracking-wider">
                {t('account')}
              </h3>
              <ul className="space-y-2">
                <li><Link to={signInRoute.to as any} params={signInRoute.params as any} className="inline-flex min-h-11 min-w-11 items-center rounded-lg px-2 text-muted transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">{t('signIn')}</Link></li>
                <li><Link to={signUpRoute.to as any} params={signUpRoute.params as any} className="inline-flex min-h-11 min-w-11 items-center rounded-lg px-2 text-muted transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">{t('register')}</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="h-px bg-divider/40" />

        <ComplianceNotice />

        <div className="h-px bg-divider/40" />

        <div className="py-4">
          <p className="text-xs text-muted">
            &copy;
            {' '}
            {currentYear}
            {' '}
            {t('copyright')}
          </p>
        </div>
      </div>
    </footer>
  )
}
